/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    videoNote : [],
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetVideoNoteAction.REQUEST_GETVIDEONOTE:
      return {
        ...state,
    };
    case actions.GetVideoNoteAction.GETVIDEONOTE_RECEIVED:
          return{
      ...state,
      videoNote : action.data.videoNote,
    };

    default:
      return state;
  }
};

export default reducer;
